import { PopperPlacementType } from '@material-ui/core/Popper'
import React, { CSSProperties, useEffect, useState } from 'react'
import { is } from '../../MediaQuery'
import { RangeType } from '../DateRangeInput'
import DayCountText from './components/DayCountText'
import SaveDatesButton from './components/SaveDatesButton'
import DatePickerDrawer from './DatePickerDrawer'
import DatePickerPopper from './DatePickerPopper'
import DateRangePickerWidget from './DateRangePickerWidget'
import { DatePickerDrawerFooter } from './styled'

interface IDateRangePickerProps {
  anchorEl: Element
  arrowRef?: Element
  open?: boolean
  styles?: CSSProperties
  placement?: PopperPlacementType
  initialStartDate?: Date
  initialEndDate?: Date
  disabledDays?: Date[]
  onStartDateChange?: (date: Date) => void
  onEndDateChange?: (date: Date) => void
  onFocusChange?: (focus: RangeType) => void
  onClose?: () => void
  initialFocus?: RangeType
  allowEndOnDisabledDay?: boolean
  allowSingleDay?: boolean
  minDate?: Date
  maxDate?: Date
  withYearPicker?: boolean
}

export default ({
                  open,
                  initialStartDate,
                  initialEndDate,
                  onStartDateChange,
                  onEndDateChange,
                  onClose,
                  allowEndOnDisabledDay,
                  ...rest
                }: IDateRangePickerProps) => {
  const isMobile = is.mobile()
  const [startDate, setStartDate] = useState(undefined)
  const [endDate, setEndDate] = useState(undefined)

  useEffect(() => {
    if (open) {
      setStartDate(initialStartDate)
      setEndDate(initialEndDate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const saveDateChanges = (start?: Date, end?: Date) => {
    onEndDateChange && onEndDateChange(null)
    onStartDateChange && onStartDateChange(start || startDate)
    onEndDateChange && onEndDateChange(end || endDate)
    onClose && onClose()
  }

  const widget = (
    <DateRangePickerWidget
      startDate={startDate}
      endDate={endDate}
      saveDateChanges={saveDateChanges}
      setEndDate={setEndDate}
      setStartDate={setStartDate}
      allowEndOnDisabledDay={allowEndOnDisabledDay}
      {...rest}
    />
  )

  if (isMobile) {
    return (
      <DatePickerDrawer open={open} onClose={onClose} {...rest}>
        <>
          {widget}
          <DatePickerDrawerFooter>
            <DayCountText
              startDate={startDate}
              endDate={endDate}
              includeEnd={!allowEndOnDisabledDay}
            />
            <SaveDatesButton
              isDisabled={!startDate || !endDate}
              onClick={saveDateChanges}
            />
          </DatePickerDrawerFooter>
        </>
      </DatePickerDrawer>
    )
  }

  return (
    <DatePickerPopper open={open} onClose={onClose} {...rest}>
      {widget}
    </DatePickerPopper>
  )
}
